import { Component, Output, Input , EventEmitter, Injectable} from '@angular/core';

/**
 * Generated class for the UpsellProductBoxComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Injectable({ providedIn: 'root' })
@Component({
  selector: 'upsell-product-box',
  templateUrl: 'upsell-product-box.html',
  styleUrls: ['upsell-product-box.scss'],
})
export class UpsellProductBoxComponent {
  @Input() title: string = '';
  @Input() showTitle: boolean = true;
  @Input() image: string = 'assets/img/No-Image-Available.jpg';
  @Input() imageAlt: string = '';
  @Input() auxImg: any = null;
  @Input() auxImgAlt: string = '';
  @Input() subTitle: string = '';
  @Input() regularPrice: number = 0;
  @Input() instantSavings: number = 0;
  @Input() yourPrice: number = 0;
  @Input() currency: string = 'USD';  // TOUC-14710
  @Input() currencySymbol: string = '$';
  @Input() officialCurrency: string = 'USD';
  @Input() braintreeCurrencyConversion: number = 1;

  @Input() yesButtonText: string = 'YES I WANT THIS SPECIAL ADDED TO MY ORDER'; // TOUC-1243
  @Input() noButtonText: string = 'NO THANKS, I UNDERSTAND THAT I WON\'T SEE THIS OFFER AGAIN'; // TOUC-1243
  @Input() yesButtonMobileText: string = 'YES I WANT THIS SPECIAL ADDED TO MY ORDER'; // TOUC-1243
  @Input() noButtonMobileText: string = 'NO THANKS, I UNDERSTAND THAT I WON\'T SEE THIS OFFER AGAIN'; // TOUC-1243

  @Input() isAmazon: boolean = false;
  @Input() isPlaceOrder: boolean = true;
  @Input() showImage: boolean = true;

  @Input() subtitle: string = "Subtitle";
  @Input() buttonId: string = ''; //What does this do? Can I remove?
  @Input() walletId: string = ''; //What does this do? Can I remove?
  @Input() regularText: string = 'Regular Price';
  @Input() instantSavingsText: string = 'Instant Savings';
  @Input() yourPriceText: string = 'Your Price';
  @Output() button_emitter: EventEmitter<boolean> = new EventEmitter();
  @Output() amazonPaymentEmitter: EventEmitter<void> = new EventEmitter();
  button_value: boolean;


  constructor() {
  }

  nextPage(btn_val: boolean) {
    this.button_value = btn_val ? true : false;
    this.button_emitter.emit(this.button_value);
  }
  payWithAmazon() {
    this.amazonPaymentEmitter.emit();
  }
}
